import { createGlobalStyle } from 'styled-components';

/**
 * Global styles and resets. This is no place for class names!
 * @see @vimeo/iris for original reset styles
 * @todo replace with https://polished.js.org/docs/#normalize after upgrade to v4
 */

// import { normalize } from 'polished';
// const GlobalStyles = createGlobalStyle`${normalize()}`;
// There are significant differences between our reset and normalize.

export const GlobalStyles = createGlobalStyle`
  *,
  *::before,
  *::after {
      box-sizing: inherit;
  }

  :root {
    color-scheme: ${({ theme }) => theme.name}
  }

  html {
      box-sizing: border-box;
      font-family: Arial, system-ui, sans-serif;
      background-color: ${({ theme }) => theme.content.background};
  }

  // for Bokeh html
  html[data-theme='dark'] {
    background-color: var(--vimeo-colors-background);
  }

  #root {
      min-height: 100%;
  }
  body {
      overflow-y: auto;
  }
  body,
  form {
      margin: 0;
      padding: 0;
  }
  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  figure,
  p,
  pre {
      margin: 0;
  }
  p:first-child,
  p {
      margin-top: 0;
  }
  img {
      border: 0;
  }
  fieldset,
  legend {
      margin: 0;
      padding: 0;
      border: 0;
  }
  acronym {
      cursor: help;
  }
  time {
      cursor: default;
  }
  em {
      font-style: italic;
  }
  sup {
      vertical-align: top;
  }
  /**
  * Suppress the focus outline on links that cannot be accessed via keyboard.
  * This prevents an unwanted focus outline from appearing around elements that
  * might still respond to pointer events.
  */
  [tabindex='-1']:focus {
      outline: none !important;
  }
  ol,
  ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
  }
`;
